import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { MyVehiclesPage } from '@/features/vehicles/my-vehicles-page';
import { VEHICLE_STAGE_VALUES } from '@/features/vehicles/vehicle-journey';

export const Route = createFileRoute('/vehicles/')({
	/** Обраний етап — в адресі: «авто, що чекають оплати» має бути посиланням. */
	validateSearch: (raw: Record<string, unknown>): { stage?: string } => {
		const stage = typeof raw.stage === 'string' && VEHICLE_STAGE_VALUES.includes(raw.stage) ? raw.stage : undefined;
		return { stage };
	},
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: { redirect: '/vehicles' } });
	},
	component: MyVehiclesPage,
	staticData: { workspace: true },
});
